import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const ResourcesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/resources/resources" */
    'routes/Resources/ResourcesRoute'
  )
));

const AssociationsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/resources/associations" */
    'routes/Resources/AssociationsRoute'
  )
));

const AssociationRecordsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/resources/association-records" */
    'routes/Resources/AssociationRecordsRoute'
  )
));

const PropertiesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/resources/properties" */
    'routes/Resources/PropertiesRoute'
  )
));

const RecordsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/resources/records" */
    'routes/Resources/RecordsRoute'
  )
));


const getResourcesRoutes = () => {
  return [
    {path: paths.getPathOnVoardResources(), render: (props) => <ResourcesRoute {...props} type={constants.RESOURCE_TYPE_ONVOARD} />},
    {path: paths.getPathExternalResources(), render: (props) => <ResourcesRoute {...props} type={constants.RESOURCE_TYPE_EXTERNAL} />},
    {path: paths.getPathCustomResources(), render: (props) => <ResourcesRoute {...props} type={constants.RESOURCE_TYPE_CUSTOM} />},

    {path: paths.getPathPredefinedResourceAssociations(), render: (props) => <AssociationsRoute {...props} type={constants.ASSOCIATION_TYPE_PREDEFINED} />},
    {path: paths.getPathCustomResourceAssociations(), render: (props) => <AssociationsRoute {...props} type={constants.ASSOCIATION_TYPE_CUSTOM} />},

    {path: paths.getPathResourceAssociationRecords(":associationKey"), component: AssociationRecordsRoute},
    {path: paths.getPathResourceProperties(":accessor"), component: PropertiesRoute},
    {path: paths.getPathResourceRecords(":accessor"), component: RecordsRoute},
  ]
}



export { getResourcesRoutes };
